<template>
  <div 
    class="banner-ubicasa" 
    :class="{ 'banner-hidden': isHidden }"
    @click="openUbicasa"
  >
    <div class="banner-content">
      <div class="logo-section">
        <div class="logo-container">
          <svg
            class="ubicasa-logo"
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
            aria-label="Logo de Ubicasa - Portal Inmobiliario"
          >
            <!-- Marcador de mapa estilo Ubicasa -->
            <path
              d="M50,10 C30,10 10,30 10,50 C10,70 50,90 50,90 C50,90 90,70 90,50 C90,30 70,10 50,10 Z"
              fill="#FFD54F"
            />
            <path
              d="M50,35 C58.2843,35 65,41.7157 65,50 C65,58.2843 58.2843,65 50,65 C41.7157,65 35,58.2843 35,50 C35,41.7157 41.7157,35 50,35 Z"
              fill="#7E57C2"
            />
            <path
              d="M50,40 C55.5228,40 60,44.4772 60,50 C60,55.5228 55.5228,60 50,60 C44.4772,60 40,55.5228 40,50 C40,44.4772 44.4772,40 50,40 Z"
              fill="white"
            />
          </svg>
        </div>
        <div class="logo-text">UBICASA</div>
      </div>

      <div class="banner-message">
        <h3>Descubre propiedades en Ubicasa</h3>
        <p>
          Tu portal inmobiliario con miles de propiedades exclusivas en Perú
        </p>
        <!-- Texto oculto para SEO con palabras clave -->
        <div class="seo-text" aria-hidden="true">
          Ubicasa es el mejor portal inmobiliario con propiedades, casas,
          departamentos y terrenos en venta y alquiler. Encuentra tu hogar ideal
          con Ubicasa Perú.
        </div>
      </div>

      <div class="banner-actions">
        <a
          href="https://ubicasa.pe"
          @click.stop="openUbicasa"
          class="ubicasa-btn"
          rel="noopener noreferrer"
          title="Visitar Ubicasa - Portal Inmobiliario"
          aria-label="Explorar propiedades en Ubicasa"
        >
          <span>Explorar ahora</span>
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M10 7L15 12L10 17"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </a>
        <button
          @click.stop="hideBanner"
          class="close-btn"
          aria-label="Cerrar banner de Ubicasa"
        >
          &times;
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BannerUbicasa",
  data() {
    return {
      isHidden: false,
    };
  },
  methods: {
    openUbicasa(event) {
      // Prevenir comportamiento por defecto solo si es un enlace
      if (event && event.preventDefault) {
        event.preventDefault();
      }
      // Abrir Ubicasa en una nueva pestaña
      window.open("https://ubicasa.pe", "_blank", "noopener,noreferrer");
    },
    hideBanner(event) {
      // Prevenir que el clic se propague al contenedor principal
      if (event) {
        event.stopPropagation();
      }
      this.isHidden = true;
    },
  },
  mounted() {
    // Siempre mostrar el banner al cargar
    this.isHidden = false;

    // Pequeño delay para mejor UX
    setTimeout(() => {
      this.isHidden = false;
    }, 1000);
  },
};
</script>

<style scoped>
.banner-ubicasa {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  max-width: 950px;
  background: linear-gradient(135deg, #6a1b9a 0%, #7e57c2 100%);
  color: white;
  padding: 20px 25px;
  z-index: 1000;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2), 0 0 15px rgba(126, 87, 194, 0.4);
  border-radius: 12px;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  border: 1px solid rgba(255, 255, 255, 0.1);
  cursor: pointer;
}

.banner-hidden {
  opacity: 0;
  visibility: hidden;
  transform: translate(-50%, 100px);
}

.banner-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.logo-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.logo-container {
  width: 55px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  padding: 5px;
}

.ubicasa-logo {
  width: 45px;
  height: 45px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

.logo-text {
  font-weight: 800;
  font-size: 13px;
  margin-top: 5px;
  letter-spacing: 1.5px;
  color: white;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.banner-message {
  flex-grow: 1;
  padding: 0 15px;
  position: relative;
}

.banner-message h3 {
  margin: 0 0 8px 0;
  font-size: 19px;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.banner-message p {
  margin: 0;
  font-size: 15px;
  opacity: 0.95;
  line-height: 1.4;
}

.seo-text {
  position: absolute;
  opacity: 0;
  height: 0;
  overflow: hidden;
  pointer-events: none;
}

.banner-actions {
  display: flex;
  align-items: center;
  gap: 15px;
}

.ubicasa-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(45deg, #ffd54f, #ffc107);
  color: #5e35b1;
  border: none;
  padding: 12px 22px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: bold;
  transition: all 0.3s ease;
  box-shadow: 0 4px 10px rgba(255, 213, 79, 0.3);
  text-decoration: none;
}

.ubicasa-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(255, 213, 79, 0.4);
  color: #5e35b1;
}

.ubicasa-btn:active {
  transform: translateY(0);
}

.close-btn {
  background: rgba(255, 255, 255, 0.15);
  color: white;
  border: none;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: rotate(90deg);
}

/* Responsive */
@media (max-width: 900px) {
  .banner-ubicasa {
    width: 95%;
    padding: 18px;
    bottom: 15px;
  }

  .banner-content {
    flex-direction: column;
    text-align: center;
    gap: 15px;
  }

  .banner-message {
    padding: 0;
  }

  .banner-message h3 {
    font-size: 17px;
  }

  .banner-message p {
    font-size: 14px;
  }

  .banner-actions {
    width: 100%;
    justify-content: center;
  }

  .logo-container {
    width: 50px;
    height: 50px;
  }

  .ubicasa-logo {
    width: 40px;
    height: 40px;
  }
}

@media (max-width: 480px) {
  .banner-ubicasa {
    padding: 15px;
  }

  .banner-message h3 {
    font-size: 16px;
  }

  .banner-message p {
    font-size: 13px;
  }

  .ubicasa-btn {
    padding: 10px 18px;
    font-size: 14px;
  }
}
</style>